<script lang="ts">
import {defineComponent} from 'vue'
import {ROUTES} from "../router";
import GlobalButton from "@global/global-elements/global-button/global-button.vue";

export default defineComponent({
    name: "MediaGalleryTermAndConditions",
    components: {GlobalButton},
    methods: {
        accept() {
            this.$store.dispatch('acceptTerms')
            this.$router.push(ROUTES.SEARCH)
        }
    }
})
</script>

<template>
    <div class="container">
        <div class="row">
            <div class="ce-wrapper">
                <div class="ce-text ce-bodytext" v-html="$t('mediaGallery.terms.conditions')"></div>
                <div class="media-gallery__terms__actions">
                    <global-button @click="accept">{{ $t('mediaGallery.terms.button') }}</global-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
